<template>
    <div>
        <div class="mx-auto my-12" style="height: 84vh; width: 90vw;">
            <v-progress-linear v-if="loading" :indeterminate="true" color="primary" height="12" />
            <l-map :zoom="map.zoom" :center="map.currentLocation" id="map" ref="myMap" :options="{ zoomControl: false }">
                <l-tile-layer :url="map.url"></l-tile-layer>
                <l-marker v-for="point of points" :lat-lng="point.cord" :key="point.key" @click="showDetails(point)"/>
            </l-map>
        </div>

        <PointDetails :point="modalData" :show="showModal" @close="closeDetails"></PointDetails>
    </div>
</template>

<script>
import PointDetails from "./PointDetails";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
    components: {
        PointDetails,
        LMap,
        LTileLayer,
        LMarker,
    },

    data() {
        return {
            loading: true,
            timer: null,
            showModal: false,
            modalData: null,
            map: {
                zoom: 9,
                url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                currentLocation: [-23.148706, -46.551336],
            },
            points: [],
        };
    },

    async mounted() {
        this.update();
        this.timer = setInterval(this.update, 5000);
    },

    methods: {
        showDetails(point) {
            this.modalData = point;
            this.showModal = true;
        },
        closeDetails() {
            this.modalData = null;
            this.showModal = false;
        },
        update() {
            this.loading = true;
            this.$http
                .get(`expert-tracking`, { continuous: true })
                .then((result) => {
                    if (result && result.length > 0) {
                        this.points = result.map((item) => {
                            return {
                                cord: L.latLng(item.latitude, item.longitude),
                                ...item
                            };
                        });
                    } else {
                        this.points = [];
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
#map {
    z-index: 0;
}
</style>